<template>
  <svg viewBox="0 0 222 232" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M148.814 0H221.494V232H131.471L75.7742 108.264H72.6799V232H0V0H90.0223L145.72 123.736H148.814V0Z"
      fill="currentColor"
    />
  </svg>
</template>
